/*
 * @Description: 优惠券可用券门店列表
 * @Author: maowy
 * @Date: 2020-7-16 18:28:16
 * @LastEditTime: 2021-08-20 11:38:32
 * @LastEditors: kayvor
 */
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import {
    getBdCouponUseSstoreList
} from '@/models/coupon'
import infiniteLoadData from '@/components/infiniteLoadData/infiniteLoadData.vue'
import couponStoreListSearch from './couponStoreListSearch/couponStoreListSearch'
import infiniteLoading from 'vue-infinite-loading'
export default {
    name: viewName.couponStoreList,
    inject: ['showLoading', 'hideLoading'],
    components: {
        infiniteLoadData,
        infiniteLoading,
        couponStoreListSearch
    },
    data () {
        return {
            clientHeight: 0,
            currentSelected: '',
            count: 0,
            nearbySstoresList: [],
            isload: true,
            param: {
                page: 0,
                pagesize: 20,
            },
            jumpWXParams: {}
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({ appInfo }) => appInfo.isWeixin,
        })
    },
    created () {
        document.body.scrollIntoView()
        this.$emit('setHeader', {
            title: '可用券门店',
            showHeader: true,
            showLeft: true
        })
        this.setAppClass({
            isAppend: false,
            className: 'bgGreyColor'
        })
    },
    activated () {
    },
    mounted () {
        const {
            coupon_id,
            latitude,
            longitude,
            receive_id: user_receive_coupon_id,
            coupon_type = '',
            is_details = '',
            showWXbtn
        } = this.$route.query
        Object.assign(this.param, {
            coupon_id,
            latitude,
            longitude,
        })
        Object.assign(this.jumpWXParams, {coupon_id, user_receive_coupon_id, coupon_type, is_details, showWXbtn})
    },
    methods: {
        ...mapActions([
            'getBdCouponUseSstoreList',
            'setAppClass'
        ]),
        getWechatPage (wechatSstoreId = '', sstoreId = '') {
            const { user_receive_coupon_id = '', coupon_type = '', is_details = '', coupon_id } = this.jumpWXParams
            return `package/coupon/pages/couponGoodsList/couponGoodsList.html?user_receive_coupon_id=${user_receive_coupon_id}&coupon_id=${coupon_id}&coupon_type=${coupon_type}&is_details=${is_details}&sstore_id=${sstoreId}&wechat_sstore_id=${wechatSstoreId}`
        },
        initParams () {
            Object.assign(this.param, {
                keyword: '',
                page: 0,
                pagesize: 20,
            })
            this.nearbySstoresList = []
        },
        onSearch (name) {
            this.initParams()
            Object.assign(this.param, {
                keyword: name
            })
            this.getPageList()
        },
        // 获取门店-分页
        getPageList () {
            if (this.nearbySstoresList.length <= this.count) {
                this.param.page++
                this.isload = true
                this.getData(this.param)
            } else {
                //  到底部了。
                // this.getData(param)
                this.isload = false
            }
        },
        getData () {
            // this.showLoading()
            getBdCouponUseSstoreList(this.param).then(res => {
                // this.hideLoading()
                const { list, count } = res
                this.count = count
                this.nearbySstoresList = this.nearbySstoresList.concat(list)
                this.$nextTick(() => {
                    this.clientHeight = Number(document.querySelector('.searchBox').clientHeight) + Number(document.querySelector('.store-list-count').clientHeight)
                })
                if (list.length < this.param.pagesize) {
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
                } else {
                    // this.page_no += 1
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.loaded()
                }
                // 返回数据 < 最大条目数
                // if (list.length < this.param.pagesize) {
                //     this.isload = false
                // } else {
                //     this.isload = true
                // }
            }).catch(_ => {
                // this.hideLoading()
                this.isload = false
            })
        },
        // /**
        //  * 上拉加载数据，在这里进行操作
        //  */
        // scrollToEnd (scroll) {
        //     this.isload && this.getPageList()
        // },
        // /**
        //  * 监听是否初始化成功
        //  */
        // init (scroll) {
        //     this.scroll = scroll
        //     this.getPageList()
        // },

        infinite () {
            this.getPageList()
        },
    },
}
